// Icon.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';  // Icône pour le panier de commande

const IconShoppingCart = ({ icon = faShoppingCart, size = '3x', color = '#f5721e' }) => {
  return <FontAwesomeIcon icon={icon} size={size} color={color} />;
};

export default IconShoppingCart;
